import React, { useState } from "react";
import TenantLicenseTable from "./TenentTable";
import {
  useTenantsUsageTrackerById,
  useTenantsDataUsageTrackerById,
} from "@/hooks/useAdminDashboardService";
import moment from "moment";

interface TenantItem {
  name: string;
  subscriptions?: { licenseCount?: number; endDate?: string; plan?: string }[];
  TenantUsageCounter?: { used?: number }[];
}

const TenantDashboard: React.FC<{ view: string }> = ({ view = "" }) => {
  const [filter, setFilter] = useState<"yearly" | "monthly" | "custom">(
    "yearly",
  );
  const [customFrom, setCustomFrom] = useState<string>(
    moment().subtract(1, "day").format("YYYY-MM-DD"),
  );
  const [customTo, setCustomTo] = useState<string>(
    moment().format("YYYY-MM-DD"),
  );
  const [selectedYear, setSelectedYear] = useState<number>(moment().year());
  const [selectedMonth, setSelectedMonth] = useState<number>(
    moment().month() + 1,
  );
  const tenantId = localStorage.getItem("tenantId") ?? "";

  const [tenantFilter, setTenantFilter] = useState<
    "yearly" | "monthly" | "custom"
  >("yearly");
  const [tenantCustomFrom, setTenantCustomFrom] = useState<string>(
    moment().subtract(1, "day").format("MM-DD-YYYY"),
  );
  const [tenantCustomTo, setTenantCustomTo] = useState<string>(
    moment().format("MM-DD-YYYY"),
  );
  const [tenantSelectedYear, setTenantSelectedYear] = useState<number>(
    moment().year(),
  );
  const [tenantSelectedMonth, setTenantSelectedMonth] = useState<number>(
    moment().month() + 1,
  );

  const tenantObjectType = (() => {
    if (tenantFilter === "custom") {
      return {
        id: tenantId,
        type: "custom",
        fromDate: tenantCustomFrom,
        toDate: tenantCustomTo,
      };
    }
    if (tenantFilter === "monthly") {
      return {
        id: tenantId,
        type: "monthly",
        year: tenantSelectedYear,
        month: tenantSelectedMonth,
      };
    }
    return {
      id: tenantId,
      type: "yearly",
      year: tenantSelectedYear,
    };
  })();

  const objectType = (() => {
    if (filter === "custom") {
      return {
        id: tenantId,
        type: "custom",
        fromDate: customFrom,
        toDate: customTo,
      };
    }
    if (filter === "monthly") {
      return {
        id: tenantId,
        type: "monthly",
        year: selectedYear,
        month: selectedMonth,
      };
    }
    return {
      id: tenantId,
      type: "yearly",
      year: selectedYear,
    };
  })();

  const { data: tenantUsageData, isError: isUsageError } =
    useTenantsUsageTrackerById(objectType);

  const tenantsUsedItems: TenantItem[] =
    !isUsageError && Array.isArray(tenantUsageData) ? tenantUsageData : [];

  const { data: tenantDataUsageData, isError: isUsageTenantError } =
    useTenantsDataUsageTrackerById(tenantObjectType);

  const tenantsDataUsedItems: TenantItem[] =
    !isUsageTenantError && Array.isArray(tenantDataUsageData)
      ? tenantDataUsageData
      : [];

  console.log("..", customTo);
  return (
    <div className={view === "dashboard" ? "p-0" : "mt-20 p-4"}>
      <TenantLicenseTable
        data={tenantsUsedItems}
        filter={filter}
        customFrom={customFrom}
        customTo={customTo}
        setFilter={setFilter}
        setCustomFrom={setCustomFrom}
        setCustomTo={setCustomTo}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
      />
      <br />
      {location?.pathname === "/usage-tracker" && (
        <>
          <TenantLicenseTable
            data={tenantsDataUsedItems}
            filter={tenantFilter}
            customFrom={tenantCustomFrom}
            customTo={tenantCustomTo}
            setFilter={setTenantFilter}
            setCustomFrom={setTenantCustomFrom}
            setCustomTo={setTenantCustomTo}
            selectedYear={tenantSelectedYear}
            setSelectedYear={setTenantSelectedYear}
            selectedMonth={tenantSelectedMonth}
            setSelectedMonth={setTenantSelectedMonth}
            isTenant={true}
          />
        </>
      )}
    </div>
  );
};

export default TenantDashboard;
